module.exports = __webpack_public_path__ + "img/hero-wms.29664acb.jpg";